
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("e6Iiv", function(module, exports) {

$parcel$export(module.exports, "ComposableEditor", () => $a840efb09fa6938c$export$36a7c46ebbddbc5d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2YULk = parcelRequire("2YULk");

var $b5IZN = parcelRequire("b5IZN");
function $a840efb09fa6938c$export$36a7c46ebbddbc5d(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const AppearanceComponent = (0, $gwFzn.useMemo)(()=>(0, $2YULk.default)(props.appearance), [
        props.appearance
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $b5IZN.CoreEditor), {
        ...props,
        AppearanceComponent: AppearanceComponent
    });
}

});
parcelRegister("2YULk", function(module, exports) {

$parcel$export(module.exports, "default", () => $607d01f653400a02$export$2e2bcd8739ae039);

var $1PKpt = parcelRequire("1PKpt");

var $6cQbn = parcelRequire("6cQbn");

var $2NcJL = parcelRequire("2NcJL");
function $607d01f653400a02$export$2e2bcd8739ae039(appearance) {
    appearance = appearance || 'comment';
    switch(appearance){
        case 'full-page':
        case 'full-width':
            return 0, $2NcJL.FullPageEditor;
        case 'chromeless':
            return 0, $1PKpt.default;
        case 'comment':
            return 0, $6cQbn.CommentEditorWithIntl;
        default:
            throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
    }
}

});
parcelRegister("2NcJL", function(module, exports) {

$parcel$export(module.exports, "FullPageEditor", () => $add8e6b8e65420e3$export$a15423dd96de66f2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $d7ZU3 = parcelRequire("d7ZU3");

var $1Oo9w = parcelRequire("1Oo9w");

var $3bEAg = parcelRequire("3bEAg");

var $b3YrF = parcelRequire("b3YrF");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $4pit1 = parcelRequire("4pit1");

var $fI0MM = parcelRequire("fI0MM");

var $js48Y = parcelRequire("js48Y");

var $12sfg = parcelRequire("12sfg");
const $add8e6b8e65420e3$var$useShowKeyline = (contentAreaRef)=>{
    const [showKeyline, setShowKeyline] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!contentAreaRef.current?.contentArea) return;
        const intersection = new IntersectionObserver(([entry])=>{
            setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
        }, {
            root: undefined,
            // Safari seems to miss events (on fast scroll) sometimes due
            // to differences in IntersectionObserver behaviour between browsers.
            // By lowering the threshold a little it gives Safari more
            // time to catch these events.
            threshold: (0, $d7ZU3.browser).safari ? 0.98 : 1
        });
        intersection.observe(contentAreaRef.current.contentArea);
        return ()=>{
            intersection.disconnect();
        };
    }, [
        contentAreaRef
    ]);
    return showKeyline;
};
const $add8e6b8e65420e3$var$hasCustomComponents = (components)=>{
    if (!components) return false;
    if ('before' in components) return Array.isArray(components.before) && components.before.length > 0 || !!components.before || Array.isArray(components.after) && components.after.length > 0 || !!components.after;
    return true;
};
const $add8e6b8e65420e3$export$a15423dd96de66f2 = (props)=>{
    const wrapperElementRef = (0, $gwFzn.useMemo)(()=>props.innerRef, [
        props.innerRef
    ]);
    const scrollContentContainerRef = (0, $gwFzn.useRef)(null);
    const showKeyline = $add8e6b8e65420e3$var$useShowKeyline(scrollContentContainerRef);
    const editorAPI = props.editorAPI;
    const { editorViewModeState: editorViewModeState, primaryToolbarState: primaryToolbarState, interactionState: interactionState } = (0, $1Oo9w.useSharedPluginState)(editorAPI, [
        'editorViewMode',
        'primaryToolbar',
        'interaction'
    ]);
    const viewMode = (0, $js48Y.getEditorViewMode)(editorViewModeState, props.preset);
    const hasHadInteraction = (0, $dh538.fg)('platform_editor_interaction_api_refactor') ? interactionState?.interactionState !== 'hasNotHadInteraction' : Boolean(interactionState?.hasHadInteraction);
    let toolbarDocking = (0, $b3YrF.useSharedPluginStateSelector)(editorAPI, 'selectionToolbar.toolbarDocking');
    if (!toolbarDocking && (0, $dh538.fg)('platform_editor_controls_toolbar_ssr_fix')) {
        // This is a workaround for the rendering issue with the selection toolbar
        // where using useSharedPluginStateSelector or useSharedPluginState the state are not
        // available when the editor is first loaded. and cause the toolbar to blink.
        const defaultDocking = props.__livePage ? 'none' : 'top';
        toolbarDocking = editorAPI?.selectionToolbar?.sharedState.currentState()?.toolbarDocking ?? defaultDocking;
    }
    let primaryToolbarComponents = props.primaryToolbarComponents;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    let isEditorToolbarHidden = (0, $dh538.fg)('platform_editor_sync_editor_view_mode_state') ? viewMode === 'view' : editorViewModeState?.mode === 'view';
    if (props.__livePage && !(0, $iu6m9.editorExperiment)('live_pages_graceful_edit', 'control')) {
        // the custom toolbar logic should only be applied when the experiment cohort is not control,
        // and the editor is in live page mode.
        if (!editorViewModeState) // when first loading the editor, the toolbar should be hidden for all content modes
        // the editorViewMode plugin state is not able to be relied as it will not be setup when
        // the appearance component is being rendered.
        // In this case we set the toolbar to be hidden by default.
        isEditorToolbarHidden = true;
        else if ((0, $iu6m9.editorExperiment)('live_pages_graceful_edit', 'initially-hide-toolbar')) // for the initially-hide-toolbar variant, the toolbar should be hidden based on
        // a separate flag in the editorViewMode plugin state.
        isEditorToolbarHidden = !editorViewModeState._showTopToolbar || false;
    }
    const { customPrimaryToolbarComponents: customPrimaryToolbarComponents } = props;
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        if ((0, $dh538.fg)('platform_editor_controls_toolbar_ssr_fix')) {
            if (toolbarDocking === 'none') {
                primaryToolbarComponents = [];
                if (!$add8e6b8e65420e3$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
            }
        } else {
            if (toolbarDocking !== 'top') primaryToolbarComponents = [];
            if (!primaryToolbarComponents?.length && !$add8e6b8e65420e3$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
        }
    }
    const popupsBoundariesElement = props.popupsBoundariesElement || scrollContentContainerRef?.current?.containerArea || undefined;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3bEAg.ContextPanelWidthProvider), null, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $12sfg.fullPageEditorWrapper),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, !(0, $iu6m9.editorExperiment)('live_pages_graceful_edit', 'control') && /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $add8e6b8e65420e3$var$hiddenStyle,
        "data-hidden": isEditorToolbarHidden
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $fI0MM.FullPageToolbar), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    })), (0, $iu6m9.editorExperiment)('live_pages_graceful_edit', 'control') && !isEditorToolbarHidden && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $fI0MM.FullPageToolbar), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4pit1.FullPageContentArea), {
        editorAPI: editorAPI,
        ref: scrollContentContainerRef,
        appearance: props.appearance,
        contentComponents: props.contentComponents,
        contextPanel: props.contextPanel,
        customContentComponents: props.customContentComponents,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        providerFactory: props.providerFactory,
        wrapperElement: wrapperElementRef?.current ?? null,
        pluginHooks: props.pluginHooks,
        featureFlags: props.featureFlags,
        isEditorToolbarHidden: isEditorToolbarHidden,
        viewMode: editorViewModeState?.mode,
        hasHadInteraction: hasHadInteraction
    })));
};
const $add8e6b8e65420e3$var$hiddenStyle = (0, $3jLHL.css)({
    visibility: 'visible',
    opacity: 1,
    transition: '200ms opacity, 200ms visibility, 200ms transform',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-hidden="true"]': {
        height: 0,
        visibility: 'hidden',
        opacity: 0
    }
});

});
parcelRegister("3bEAg", function(module, exports) {

$parcel$export(module.exports, "ContextPanelWidthProvider", () => $31e4d3a4f86e133c$export$ba19517e2c08f4aa);
$parcel$export(module.exports, "ContextPanelConsumer", () => $31e4d3a4f86e133c$export$24734d8d7782a3fc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $31e4d3a4f86e133c$export$c174a7dc96b2afb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    width: 0,
    positionedOverEditor: false,
    broadcastWidth: ()=>{},
    broadcastPosition: ()=>{}
});
class $31e4d3a4f86e133c$export$ba19517e2c08f4aa extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
        return /*#__PURE__*/ (0, $7UHDa.jsx)($31e4d3a4f86e133c$export$e38af27e662e9783, {
            value: {
                width: width,
                positionedOverEditor: positionedOverEditor,
                broadcastWidth: this.broadcastSidebarWidth,
                broadcastPosition: this.broadcastPosition
            },
            children: this.props.children
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props);
        this.state = {
            width: 0,
            positionedOverEditor: false
        };
        this.broadcastSidebarWidth = (width)=>{
            if (width !== this.state.width) this.setState({
                width: width
            });
        };
        this.broadcastPosition = (positionedOverEditor)=>{
            if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                positionedOverEditor: positionedOverEditor
            });
        };
    }
}
const { Provider: $31e4d3a4f86e133c$export$e38af27e662e9783, Consumer: $31e4d3a4f86e133c$export$24734d8d7782a3fc } = $31e4d3a4f86e133c$export$c174a7dc96b2afb8;

});

parcelRegister("4pit1", function(module, exports) {

$parcel$export(module.exports, "FullPageContentArea", () => $f148f84351b38b5e$export$7db1e8e055ebd208);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");
var $ja596 = parcelRequire("ja596");

var $6qIXK = parcelRequire("6qIXK");

var $js7oX = parcelRequire("js7oX");

var $8aWkM = parcelRequire("8aWkM");

var $26eEE = parcelRequire("26eEE");

var $dh538 = parcelRequire("dh538");

var $9JpPs = parcelRequire("9JpPs");

var $iu6m9 = parcelRequire("iu6m9");

var $kXpLO = parcelRequire("kXpLO");

var $45E6y = parcelRequire("45E6y");

var $761rI = parcelRequire("761rI");

var $auRzv = parcelRequire("auRzv");

var $axOCf = parcelRequire("axOCf");

var $3ae8F = parcelRequire("3ae8F");

var $12sfg = parcelRequire("12sfg");
const $f148f84351b38b5e$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $f148f84351b38b5e$export$5c151fe82051a1a7 = 'ak-editor-container';
const $f148f84351b38b5e$var$scrollStyles = (0, $3jLHL.css)({
    flexGrow: 1,
    height: '100%',
    overflowY: 'scroll',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    scrollBehavior: 'smooth'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $26eEE.scrollbarStyles));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f148f84351b38b5e$var$ScrollContainer = (0, $761rI.createEditorContentStyle)($f148f84351b38b5e$var$scrollStyles);
$f148f84351b38b5e$var$ScrollContainer.displayName = 'ScrollContainer';
const $f148f84351b38b5e$var$EditorContainer = (0, $9JpPs.componentWithCondition)(()=>(0, $iu6m9.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $axOCf.default), $f148f84351b38b5e$var$ScrollContainer);
const $f148f84351b38b5e$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>{
    const theme = (0, $ja596.u)();
    const fullWidthMode = props.appearance === 'full-width';
    const scrollContainerRef = (0, $gwFzn.useRef)(null);
    const contentAreaRef = (0, $gwFzn.useRef)(null);
    const containerRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    let interactionClassName;
    if (props.hasHadInteraction && (0, $dh538.fg)('platform_editor_no_cursor_on_live_doc_init')) interactionClassName = props.hasHadInteraction ? 'ak-editor-has-interaction' : 'ak-editor-no-interaction';
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $12sfg.contentArea),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('live_pages_graceful_edit', 'control') && props.isEditorToolbarHidden && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $12sfg.contentAreaHeightNoToolbar)
        ],
        "data-testid": $f148f84351b38b5e$export$81adcdb8b9fca1f7,
        ref: containerRef,
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: !(0, $iu6m9.editorExperiment)('live_pages_graceful_edit', 'control') && props.isEditorToolbarHidden ? 'ak-editor-content-area-no-toolbar' : undefined
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $12sfg.contentAreaWrapper),
        "data-testid": $f148f84351b38b5e$export$5c151fe82051a1a7,
        "data-editor-container": 'true'
    }, /*#__PURE__*/ (0, $3jLHL.jsx)($f148f84351b38b5e$var$EditorContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props?.viewMode,
        isScrollable: true,
        appearance: props.appearance
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $kXpLO.default), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            ...(0, $12sfg.editorContentAreaStyle)({
                fullWidthMode: fullWidthMode,
                layoutMaxWidth: theme.layoutMaxWidth,
                isEditorToolbarHidden: props.isEditorToolbarHidden
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "ak-editor-content-area-region",
        "data-editor-editable-content": true,
        "data-editor-primary-toolbar-hidden": props.isEditorToolbarHidden && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 'true' : undefined,
        role: "region",
        "aria-label": props.intl.formatMessage((0, $8aWkM.messages).editableContentLabel),
        ref: contentAreaRef
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $12sfg.editorContentGutterStyle)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dh538.fg)('platform_editor_no_cursor_on_live_doc_init') ? (0, (/*@__PURE__*/$parcel$interopDefault($6qIXK)))('ak-editor-content-area', 'appearance-full-page', interactionClassName, {
            'fabric-editor--full-width-mode': fullWidthMode
        }) : [
            'ak-editor-content-area',
            'appearance-full-page',
            fullWidthMode ? 'fabric-editor--full-width-mode' : ''
        ].join(' '),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3ae8F.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents.after) : null))))), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $12sfg.sidebarArea)
    }, props.contextPanel || /*#__PURE__*/ (0, $3jLHL.jsx)((0, $auRzv.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
});
const $f148f84351b38b5e$export$7db1e8e055ebd208 = (0, $js7oX.default)($f148f84351b38b5e$var$Content, {
    forwardRef: true
});

});
parcelRegister("auRzv", function(module, exports) {

$parcel$export(module.exports, "ContextPanel", () => $3e0be7976f7dcf3f$export$c174a7dc96b2afb8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $iryfe = parcelRequire("iryfe");

var $1Oo9w = parcelRequire("1Oo9w");

var $3bEAg = parcelRequire("3bEAg");

var $aFUXX = parcelRequire("aFUXX");

var $dh538 = parcelRequire("dh538");
const $3e0be7976f7dcf3f$var$ANIM_SPEED_MS = 500;
const $3e0be7976f7dcf3f$var$panelHidden = (0, $3jLHL.css)({
    width: 0
});
const $3e0be7976f7dcf3f$export$21f42ab9b6679f44 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $aFUXX.akEditorContextPanelWidth)}px`,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${$3e0be7976f7dcf3f$var$ANIM_SPEED_MS}ms ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
    overflow: 'hidden',
    boxShadow: `inset 2px 0 0 0 ${"var(--ds-border, #091E4224)"}`
});
const $3e0be7976f7dcf3f$var$disablePanelAnimation = (0, $3jLHL.css)({
    transition: 'none'
});
const $3e0be7976f7dcf3f$export$a7db06668cad9adb = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width 600ms ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $aFUXX.akEditorContextPanelWidth)}px`,
    height: '100%',
    overflowY: 'auto'
});
const $3e0be7976f7dcf3f$var$paddingStyles = (0, $3jLHL.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0px`
});
class $3e0be7976f7dcf3f$export$2aac880ec6fe2608 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.pluginContent !== state.currentPluginContent) return {
            ...state,
            currentPluginContent: props.pluginContent
        };
        return null;
    }
    unsetPluginContent() {
        this.setState({
            currentPluginContent: undefined
        });
    }
    componentDidMount() {
        // use this to trigger an animation
        this.setState({
            mounted: true
        });
    }
    render() {
        const width = this.props.customWidth ?? (0, $aFUXX.akEditorContextPanelWidth);
        const userVisible = !!this.props.visible;
        const visible = userVisible || !!this.state.currentPluginContent;
        const hasPadding = this.props.hasPadding === undefined ? true : this.props.hasPadding;
        const customPanelWidthStyles = (0, $3jLHL.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @repo/internal/react/no-class-components
            width: `${this.props.customWidth}px`,
            overflowX: 'hidden'
        });
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3bEAg.ContextPanelConsumer), null, ({ broadcastWidth: broadcastWidth })=>{
            const contextPanelWidth = visible ? width : 0;
            broadcastWidth(contextPanelWidth);
            return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
                css: [
                    $3e0be7976f7dcf3f$export$21f42ab9b6679f44,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
                    this.props.customWidth && customPanelWidthStyles,
                    !visible && $3e0be7976f7dcf3f$var$panelHidden,
                    (0, $dh538.fg)('platform_editor_disable_context_panel_animation') && $3e0be7976f7dcf3f$var$disablePanelAnimation
                ],
                "data-testid": "context-panel-panel",
                "aria-labelledby": "context-panel-title",
                role: "dialog"
            }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
                "data-testid": "context-panel-content",
                css: [
                    $3e0be7976f7dcf3f$export$a7db06668cad9adb,
                    hasPadding && $3e0be7976f7dcf3f$var$paddingStyles,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
                    this.props.customWidth && customPanelWidthStyles,
                    !visible && $3e0be7976f7dcf3f$var$panelHidden,
                    (0, $dh538.fg)('platform_editor_disable_context_panel_animation') && $3e0be7976f7dcf3f$var$disablePanelAnimation
                ]
            }, this.showPluginContent() || this.showProvidedContent(userVisible)));
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            mounted: false,
            currentPluginContent: undefined
        };
        this.focusEditor = ()=>{
            const { editorAPI: editorAPI } = this.props;
            editorAPI?.core?.actions.focus({
                scrollIntoView: false
            });
        };
        this.showPluginContent = ()=>{
            const { pluginContent: pluginContent } = this.props;
            const { currentPluginContent: currentPluginContent } = this.state;
            if (!currentPluginContent) return;
            const animSpeedMs = (0, $dh538.fg)('platform_editor_disable_context_panel_animation') ? 0 : $3e0be7976f7dcf3f$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $iryfe.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: !!pluginContent,
                mountOnEnter: true,
                unmountOnExit: true,
                onExited: ()=>this.unsetPluginContent()
            }, currentPluginContent);
        };
        this.showProvidedContent = (isVisible)=>{
            const { children: children } = this.props;
            if (!children) return;
            const animSpeedMs = (0, $dh538.fg)('platform_editor_disable_context_panel_animation') ? 0 : $3e0be7976f7dcf3f$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $iryfe.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: isVisible,
                mountOnEnter: true,
                unmountOnExit: true,
                onExiting: this.focusEditor
            }, children);
        };
    }
}
function $3e0be7976f7dcf3f$export$c174a7dc96b2afb8(props) {
    const { contextPanelState: contextPanelState } = (0, $1Oo9w.useSharedPluginState)(props.editorAPI, [
        'contextPanel'
    ]);
    const firstContent = contextPanelState && contextPanelState?.contents?.find(Boolean);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $3jLHL.jsx)($3e0be7976f7dcf3f$export$2aac880ec6fe2608, {
        ...props,
        editorAPI: props.editorAPI,
        pluginContent: firstContent
    }));
}

});

parcelRegister("12sfg", function(module, exports) {

$parcel$export(module.exports, "fullPageEditorWrapper", () => $3dfe29ddb16847ad$export$ffbc962f588258d5);
$parcel$export(module.exports, "contentArea", () => $3dfe29ddb16847ad$export$26bdc8f90c1f72f6);
$parcel$export(module.exports, "contentAreaWrapper", () => $3dfe29ddb16847ad$export$484266f72d7ebbab);
$parcel$export(module.exports, "contentAreaHeightNoToolbar", () => $3dfe29ddb16847ad$export$848a137fb02bc242);
$parcel$export(module.exports, "sidebarArea", () => $3dfe29ddb16847ad$export$a838a71bfc839c1d);
$parcel$export(module.exports, "editorContentAreaStyle", () => $3dfe29ddb16847ad$export$fc070501506e6d7a);
$parcel$export(module.exports, "editorContentGutterStyle", () => $3dfe29ddb16847ad$export$95d13e1170f2991);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gF5vD = parcelRequire("gF5vD");
var $sHAtT = parcelRequire("sHAtT");

var $c4XA1 = parcelRequire("c4XA1");

var $eJQfi = parcelRequire("eJQfi");

var $aFUXX = parcelRequire("aFUXX");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $3dfe29ddb16847ad$var$SWOOP_ANIMATION = `0.5s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`;
const $3dfe29ddb16847ad$var$getTotalPadding = ()=>(0, $aFUXX.akEditorGutterPaddingDynamic)() * 2;
const $3dfe29ddb16847ad$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $3dfe29ddb16847ad$export$ffbc962f588258d5 = (0, $3jLHL.css)({
    minWidth: '340px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box'
});
const $3dfe29ddb16847ad$export$26bdc8f90c1f72f6 = ()=>{
    const editorToolbarHeight = (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return (0, $3jLHL.css)({
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% - ${editorToolbarHeight})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        '&.ak-editor-content-area-no-toolbar': {
            // The editor toolbar height is 1px off (from the border) -- so we need to add 1px to the height
            // to match the toolbar height
            height: `calc(100% + 1px)`
        },
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `padding 0ms ${(0, $aFUXX.akEditorSwoopCubicBezier)}`
    });
};
const $3dfe29ddb16847ad$export$484266f72d7ebbab = (0, $3jLHL.css)({
    width: '100%',
    containerType: 'inline-size',
    containerName: 'editor-area',
    // Chrome 129 Regression!
    // By the spec, when the container-type: inline-size is used
    // The browser should apply the bewlo properties to the element.
    // However, for reasons that goes beyond my knowledge.
    // Chrome 129 broke that behavior, and now we need to make it explicity.
    contain: 'layout style inline-size'
});
const $3dfe29ddb16847ad$export$848a137fb02bc242 = (0, $3jLHL.css)({
    height: '100%'
});
const $3dfe29ddb16847ad$export$a838a71bfc839c1d = (0, $3jLHL.css)({
    height: '100%',
    boxSizing: 'border-box',
    alignSelf: 'flex-end',
    // Make the sidebar sticky within the legacy content macro
    // to prevent it from aligning to the bottom with large content.
    // This style is only applied when opening inside the legacy content macro.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '.extension-editable-area &': {
        height: 'auto',
        position: 'sticky',
        top: 0,
        alignSelf: 'flex-start'
    }
});
const $3dfe29ddb16847ad$export$14d7990cf2a76cb6 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.pm-table-container, .code-block, .extension-container': {
            display: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.multiBodiedExtension--container': {
            display: 'none'
        }
    }
});
/* Prevent horizontal scroll on page in full width mode */ const $3dfe29ddb16847ad$var$editorContentAreaContainerStyle = ()=>(0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-editor--full-width-mode': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.code-block, .extension-container, .multiBodiedExtension--container': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% - ${(0, $eJQfi.tableMarginFullWidthMode) * 2}px)`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.extension-container.inline': {
                maxWidth: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            'td .extension-container.inline': {
                maxWidth: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '[data-layout-section]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% + ${((0, $aFUXX.akLayoutGutterOffset) + ((0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $3dfe29ddb16847ad$var$AK_NESTED_DND_GUTTER_OFFSET : 0)) * 2}px)`
            }
        }
    });
const $3dfe29ddb16847ad$export$fc070501506e6d7a = ({ layoutMaxWidth: layoutMaxWidth, fullWidthMode: fullWidthMode, isEditorToolbarHidden: isEditorToolbarHidden })=>[
        $3dfe29ddb16847ad$var$editorContentArea,
        !fullWidthMode && $3dfe29ddb16847ad$var$editorContentAreaWithLayoutWith(layoutMaxWidth),
        $3dfe29ddb16847ad$var$editorContentAreaContainerStyle(),
        ...(0, $dh538.fg)('platform_editor_controls_no_toolbar_space') ? [] : [
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            $3dfe29ddb16847ad$var$contentAreaReducedHeaderSpace,
            isEditorToolbarHidden && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            $3dfe29ddb16847ad$var$contentAreaReservedPrimaryToolbarSpace
        ]
    ];
const $3dfe29ddb16847ad$var$editorContentAreaWithLayoutWith = (layoutMaxWidth)=>(0, $3jLHL.css)({
        // this restricts max width
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${layoutMaxWidth + $3dfe29ddb16847ad$var$getTotalPadding()}px`
    });
const $3dfe29ddb16847ad$var$editorContentArea = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    paddingTop: "var(--ds-space-600, 48px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area-no-toolbar &': {
        // When the toolbar is hidden, we don't want content to jump up
        // the extra 1px is to account for the border on the toolbar
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/ui-styling-standard/no-unsafe-values
        paddingTop: `calc(${"var(--ds-space-600, 48px)"} + ${(0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)()} + 1px)`
    },
    paddingBottom: "var(--ds-space-600, 48px)",
    height: 'calc( 100% - 105px )',
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth) + $3dfe29ddb16847ad$var$getTotalPadding()}px`,
    transition: `max-width ${$3dfe29ddb16847ad$var$SWOOP_ANIMATION}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .ProseMirror': {
        flexGrow: 1,
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`> p, > ul, > ol:not(${0, $sHAtT.taskListSelector}):not(${0, $gF5vD.decisionListSelector}), > h1, > h2, > h3, > h4, > h5, > h6`]: {
            clear: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> p:last-child': {
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $c4XA1.tableFullPageEditorStyles), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-editor-breakout-mark, .extension-container.block, .pm-table-container': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            width: '100% !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-editor-breakout-mark': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            marginLeft: 'unset !important',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            transform: 'none !important'
        }
    }
});
const $3dfe29ddb16847ad$export$95d13e1170f2991 = ()=>{
    return (0, $3jLHL.css)({
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px`
    });
};
// An additional spacing applied at the top of the content area reserving space when the primary toolbar
// is hidden – this avoids layout shift when the toolbar is toggled under the editor controls feature
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3dfe29ddb16847ad$var$contentAreaReservedPrimaryToolbarSpace = (0, $3jLHL.css)({
    // extra 1px to account for the bottom border on the toolbar
    marginTop: `calc(${"var(--ds-space-500, 40px)"} + 1px)`
});
// A reduced top spacing applied to the content area to compensate for the reserved space at the top
// of the page when the primary toolbar is hidden under the editor controls feature
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3dfe29ddb16847ad$var$contentAreaReducedHeaderSpace = (0, $3jLHL.css)({
    paddingTop: "var(--ds-space-400, 32px)"
});

});


parcelRegister("fI0MM", function(module, exports) {

$parcel$export(module.exports, "FullPageToolbar", () => $351b868f15072c21$export$26f3f0e30f9545b4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $js7oX = parcelRequire("js7oX");

var $8aWkM = parcelRequire("8aWkM");

var $3bEAg = parcelRequire("3bEAg");

var $5Gwdo = parcelRequire("5Gwdo");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $9kMHa = parcelRequire("9kMHa");

var $1xxAs = parcelRequire("1xxAs");

var $5EIaX = parcelRequire("5EIaX");

var $25FDC = parcelRequire("25FDC");
const $351b868f15072c21$export$477aaffea178bc4e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>{
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $gwFzn.useState)(false);
    const { editorAPI: editorAPI } = props;
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const twoLineEditorToolbar = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? !!props.customPrimaryToolbarComponents && props.primaryToolbarComponents?.length !== 0 : !!props.customPrimaryToolbarComponents;
    // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $9kMHa.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment;
    const popupsMountPoint = hasToolbarPortal ? undefined : props.popupsMountPoint;
    const nonCustomToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $25FDC.nonCustomToolbarWrapperStyle)
    }, props.beforeIcon && /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $25FDC.mainToolbarIconBeforeStyle)
    }, props.beforeIcon), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $1xxAs.ToolbarWithSizeDetector), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: twoLineEditorToolbar
    }));
    const customToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $25FDC.customToolbarWrapperStyle)
    }, !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $5EIaX.BeforePrimaryToolbarWrapper), {
        beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
    }) : null, !((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_find_and_replace_duplication')) && editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.registerToolbarButton({
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        editorView: props.editorView,
        containerElement: props.containerElement,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
    }) : null, !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents);
    (0, $gwFzn.useEffect)(()=>{
        if (twoLineEditorToolbar) {
            const updateOnResize = ()=>{
                setShouldSplitToolbar(window.innerWidth <= (0, $25FDC.MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT));
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', updateOnResize);
            updateOnResize();
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            return ()=>window.removeEventListener('resize', updateOnResize);
        }
    });
    const isShortcutToFocusToolbar = (event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    };
    const handleEscape = (event)=>{
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3bEAg.ContextPanelConsumer), null, ({ width: contextPanelWidth })=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
            editorView: props.editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: props.intl
        }, /*#__PURE__*/ (0, $3jLHL.jsx)(ToolbarPortal, null, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $25FDC.mainToolbarStyle)(props.showKeyline || contextPanelWidth > 0, twoLineEditorToolbar),
            "data-testid": "ak-editor-main-toolbar"
        }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $25FDC.mainToolbarFirstChildStyle)(twoLineEditorToolbar),
            role: "toolbar",
            "aria-label": props.intl.formatMessage((0, $8aWkM.messages).toolbarLabel)
        }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $25FDC.mainToolbarSecondChildStyle)(twoLineEditorToolbar),
            "data-testid": "avatar-group-outside-plugin",
            role: "region",
            "aria-label": props.intl.formatMessage((0, $8aWkM.messages).pageActionsLabel)
        }, shouldSplitToolbar ? nonCustomToolbar : customToolbar), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $9kMHa.ToolbarPortalMountPoint), null)))));
});
const $351b868f15072c21$export$26f3f0e30f9545b4 = (0, $js7oX.default)($351b868f15072c21$export$477aaffea178bc4e);

});
parcelRegister("9kMHa", function(module, exports) {

$parcel$export(module.exports, "ToolbarPortalContextProvider", () => $b0152837669a5888$export$89a0c16b81a39772);
$parcel$export(module.exports, "useToolbarPortal", () => $b0152837669a5888$export$9fa9b541c351558);
$parcel$export(module.exports, "ToolbarPortalMountPoint", () => $b0152837669a5888$export$ed65ed0e830b18c8);
/* ToolbarPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $b0152837669a5888$var$ToolbarPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(undefined);
const $b0152837669a5888$export$89a0c16b81a39772 = ({ children: children, portal: portal, isActive: isActive })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>({
            Portal: portal,
            isActive: isActive
        }), [
        portal,
        isActive
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($b0152837669a5888$var$ToolbarPortalContext.Provider, {
        value: value,
        children: children
    });
};
const $b0152837669a5888$export$9fa9b541c351558 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($b0152837669a5888$var$ToolbarPortalContext);
};
const $b0152837669a5888$var$toolbarPortalStyles = {
    portal: "_1r04ze3t _kqswstnw _fiawglyw"
};
const $b0152837669a5888$export$ed65ed0e830b18c8 = ()=>{
    const portal = $b0152837669a5888$export$9fa9b541c351558(); // Don't render a mountpoint when we're already inside a portal
    if (portal) return null;
     // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $b0152837669a5888$var$toolbarPortalStyles.portal,
            "ak-editor-toolbar-portal"
        ])
    });
};

});

parcelRegister("5EIaX", function(module, exports) {

$parcel$export(module.exports, "BeforePrimaryToolbarWrapper", () => $6accd3fc044a700a$export$b41281e8d2acb8ab);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");
const $6accd3fc044a700a$var$beforePrimaryToolbarPluginWrapperStyles = (0, $3jLHL.css)({
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
    alignItems: 'center'
});
const $6accd3fc044a700a$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $6accd3fc044a700a$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);

});

parcelRegister("25FDC", function(module, exports) {

$parcel$export(module.exports, "MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT", () => $dec1329f8579fa72$export$f71dca5c73c8a7);
$parcel$export(module.exports, "mainToolbarStyle", () => $dec1329f8579fa72$export$149462a46fbcc8c8);
$parcel$export(module.exports, "mainToolbarIconBeforeStyle", () => $dec1329f8579fa72$export$8ae7cf5e67319342);
$parcel$export(module.exports, "mainToolbarFirstChildStyle", () => $dec1329f8579fa72$export$53973a689c603614);
$parcel$export(module.exports, "mainToolbarSecondChildStyle", () => $dec1329f8579fa72$export$b0242e3e235d994c);
$parcel$export(module.exports, "nonCustomToolbarWrapperStyle", () => $dec1329f8579fa72$export$a41238ec40a49ad0);
$parcel$export(module.exports, "customToolbarWrapperStyle", () => $dec1329f8579fa72$export$9c5878561f814452);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");

var $dh538 = parcelRequire("dh538");
const $dec1329f8579fa72$export$f71dca5c73c8a7 = 868;
// box-shadow is overriden by the mainToolbar
const $dec1329f8579fa72$var$mainToolbarWithKeyline = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: `${"var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"}`
});
const $dec1329f8579fa72$var$mainToolbarTwoLineStyle = ()=>{
    const editorToolbarHeight = (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$dec1329f8579fa72$export$f71dca5c73c8a7}px)`]: {
            flexWrap: 'wrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    });
};
const $dec1329f8579fa72$var$flexibleIconSize = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& span svg': {
        maxWidth: '100%'
    }
});
const $dec1329f8579fa72$var$mainToolbar = ()=>{
    const editorToolbarHeight = (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return (0, $3jLHL.css)({
        position: 'relative',
        alignItems: 'center',
        boxShadow: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `box-shadow 200ms ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: editorToolbarHeight,
        flexShrink: 0,
        backgroundColor: "var(--ds-surface, white)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& object': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            height: '0 !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
            display: 'grid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $dh538.fg)('platform-visual-refresh-icons') && $dec1329f8579fa72$var$flexibleIconSize);
};
const $dec1329f8579fa72$export$149462a46fbcc8c8 = (showKeyline, twoLineEditorToolbar)=>[
        $dec1329f8579fa72$var$mainToolbar,
        showKeyline && $dec1329f8579fa72$var$mainToolbarWithKeyline,
        twoLineEditorToolbar && $dec1329f8579fa72$var$mainToolbarTwoLineStyle
    ];
const $dec1329f8579fa72$export$8ae7cf5e67319342 = (0, $3jLHL.css)({
    margin: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $dec1329f8579fa72$var$mainToolbarFirstChild = (0, $3jLHL.css)({
    display: 'flex',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $dec1329f8579fa72$var$mainToolbarFirstChildTowLine = ()=>{
    const editorToolbarHeight = (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$dec1329f8579fa72$export$f71dca5c73c8a7}px)`]: {
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            justifyContent: 'flex-end',
            minWidth: 'fit-content'
        }
    });
};
const $dec1329f8579fa72$export$53973a689c603614 = (twoLineEditorToolbar)=>[
        $dec1329f8579fa72$var$mainToolbarFirstChild,
        twoLineEditorToolbar && $dec1329f8579fa72$var$mainToolbarFirstChildTowLine
    ];
const $dec1329f8579fa72$var$mainToolbarSecondChild = (0, $3jLHL.css)({
    minWidth: 'fit-content'
});
const $dec1329f8579fa72$var$mainToolbarSecondChildTwoLine = ()=>{
    const editorToolbarHeight = (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$dec1329f8579fa72$export$f71dca5c73c8a7}px)`]: {
            display: 'flex',
            flexGrow: 1,
            flex: '1 1 100%',
            margin: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            minWidth: 0
        }
    });
};
const $dec1329f8579fa72$export$b0242e3e235d994c = (twoLineEditorToolbar)=>[
        $dec1329f8579fa72$var$mainToolbarSecondChild,
        twoLineEditorToolbar && $dec1329f8579fa72$var$mainToolbarSecondChildTwoLine
    ];
const $dec1329f8579fa72$export$a41238ec40a49ad0 = (0, $3jLHL.css)({
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1
});
const $dec1329f8579fa72$export$9c5878561f814452 = (0, $3jLHL.css)({
    alignItems: 'center',
    display: 'flex'
});

});


parcelRegister("js48Y", function(module, exports) {

$parcel$export(module.exports, "getEditorViewMode", () => $ae6e873c251632fa$export$419814ca23c581e8);

var $dh538 = parcelRequire("dh538");
// Retrieve the initial config value from the editor view plugin preset
const $ae6e873c251632fa$var$getViewModeSync = (preset)=>{
    if (!(0, $dh538.fg)('platform_editor_sync_editor_view_mode_state')) return undefined;
    // @ts-expect-error - data is a private property
    const editorViewModePlugin = preset.data.find((p)=>{
        if (Array.isArray(p)) {
            const [plugin, config] = p;
            return plugin({
                config: config
            }).name === 'editorViewMode';
        } else return p?.({
            config: undefined
        })?.name === 'editorViewMode';
    });
    // If we have set a default value on the view mode (index 1) then we can return the mode, otherwise we haven't set by default
    return Array.isArray(editorViewModePlugin) ? editorViewModePlugin[1]?.mode : undefined;
};
const $ae6e873c251632fa$export$419814ca23c581e8 = (editorViewModeState, preset)=>{
    if (!editorViewModeState?.mode) return $ae6e873c251632fa$var$getViewModeSync(preset);
    return editorViewModeState?.mode;
};

});





//# sourceMappingURL=FullPageEditorComponent.0e7650f2.js.map
